import Vue from 'vue'
import Vuex from 'vuex'
//import createPersistedState from "vuex-persistedstate";

// Load Vuex
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    textToCopy: "",
    serverLink: "http://3ur4p2zmartexkth.servebeer.com",
    mainPageActive: true,
    pageSolarToolActive: false,
    pageSolarToolDbActive: false,
    pageSolarToolMainActive: true,
    pageSolarToolOptionsActive: false,
    pageSolarToolResultsActive: false,
    active: 0,
    api_status: "",
    databaseExported: false,
    authenticated: false,
    usersList: null,
    searchUsersList: null,
    usersListBool: [],
    usersResponse: "",
    authenticatedAdmin: false,
    axios_error: null,
    SolarToolCustomerNumber: null,
    SolarToolCustomerName: null,
    SolarToolSearchCustomerNumber: null,
    SolarToolSearchCustomerNumberInProgress: false,
    SolarToolCustomersList: null,
    SolarToolFoundCustomers: [ {
      Cust_Supp_no: '',
      Name_1: ''
    }],
    SolarToolFoundCustomersSearch: null,
    SolarToolFoundCustomersDataTableVisible: false,
    SolarToolCustomerNumberIsValid: false,
    SolarToolUploadFiles: null,
    SolarToolIsUploading: false,
    SolarToolIsUploaded: false,
    SolarToolIsCifCSV: false,
    SolarToolSessionId: "",
    SolarToolNetstoreSession: "",
    SolarToolquotationNumber: null,
    SolarToolNomProjet: {"Nom" : "" },
    SolarToolDirectory: null,
    SolarToolEsdecLink: "",
    SolarToolUserAlias: "",
    SolarToolAswJson: {"details" : [] },
    SolarToolAswJsonSearch: null,
    SolarToolAswJsonListBool: [],
    SolarToolMessages: [],
    SolarToolMessagesAvertissement: [],
    SolarToolMessagesAvertissementText: "",
    SolarToolMessagesResultat: [],
    SolarToolMessagesErreur: [],
    SolarToolMessagesErreurText: "",
    SolarToolDonneesProjet: [],
    SolarToolUploadedFilesNumber: 0,
    SolarToolOpenDialogResult: false,

    uploadResponse: null,
    dmr: 0,

    UsersHeaders: 
    [
      { text: "Nom", value: "NOM" },
      { text: "Prenom", value: "PRENOM" },
      { text: "email", value: "EMAIL" },
      { text: "Admin", align: "end", value: "ADMIN" },
      { text: "EDITER/SUPPRIMER", value: "actions", sortable: false },
    ],
    SolarToolAswJsonHeaders: 
    [
      { text: "EDITER/SUPPRIMER", value: "actions", sortable: false },
      { text: "REFERENCE", value: "itemCode" },
      { text: 'DESCRIPTION', value: "description" },
      { text: "QUANTITE", value: "quantity" },
      { text: 'UNITE', value: "unit" },
    ],
    SolarToolDonneesProjetHeaders: 
    [
      { text: "", value: "actions", sortable: false },
      { text: "Nom", value: "Nom", key: "name" },
      { text: 'Rue', value: "Rue" },
      { text: "CP", value: "Cp" },
      { text: 'Localité', value: "Localite" },
      { text: 'Pays', value: "Pays" },
    ],
    SolarToolFoundCustomersHeaders:
    [
      { text: "", value: "actions", sortable: false },
      { text: "Numéro", value: "Cust_Supp_no" },
      { text: "Nom", value: "Name_1", key: "name" },
      { text: 'Rue', value: "Address_3" },
      { text: "CP", value: "Postal_code" },
      { text: 'Localité', value: "Address_4" },
      { text: 'Pays', value: "Cntry" },
    ],
    SolarToolAswJsonEditedItem: {
      itemCode: '',
      description: '',
      quantity: '',
      unit: '',
    },

    selected: [],
    errorMessages: '',
    usersEditedItem: {
      NOM: '',
      PRENOM: '',
      EMAIL: '',
      ADMIN: false
    },
    customer: {
      SOCIETE: '',
      RUE: '',
      CP: '',
      LOCALITE: '',
      TVA: ''
    }, 
    searchedCustomers: 
    [
    ],

},
  mutations: {
  },
  actions: {
  },
  //plugins: [createPersistedState()]
})

